// test1595
(1595 && 0);
